export const ALCANCE_FICHA = {
  TODOS: 'todos',
  PROPIA: 'propia'
} as const;

export type AlcanceFicha = typeof ALCANCE_FICHA[keyof typeof ALCANCE_FICHA];
